import { fetch } from 'http-common';

type PriceParams = {
  season: string;
  marketLine: string;
  genderCode: string;
  zone: string;
  category: string;
};

type PriceInput = {
  season: string;
  zone: string;
  itemCode: string;
  mainFabricCode: string;
  genderCode: string;
  prices: string[];
};

class DistributorDataService {
  private http = fetch();

  private ep = '/v1/distributor_price';

  public async getGender(season: string, marketLine: string) {
    return this.http.get(`${this.ep}/${season}/${marketLine}`);
  }

  public async getLine(season: string, marketLine: string, genderCode: string) {
    return this.http.get(`${this.ep}/${season}/${marketLine}/${genderCode}`);
  }

  public async getPrices(params: PriceParams) {
    const { season, marketLine, genderCode, zone, category } = params;

    return this.http.get(
      `${this.ep}/${season}/${marketLine}/${genderCode}/${zone}/${category}`
    );
  }

  public putPrice(data: PriceInput) {
    return this.http.post(`${this.ep}`, data);
  }
}

const distributorDataService = new DistributorDataService();

export { distributorDataService };
